module.exports = __webpack_public_path__ + "static/media/truck-loading.0bdc2314.svg";